export const assessmentsData = [
  {
    id: 1,
    title: 'Business Pulse Check',
    category: 'strategy',
    complexity: 'basic',
    description: 'A quick 10-question assessment to gauge your overall business health and identify immediate areas for improvement.',
    fullDescription: 'Get a rapid overview of your business performance with our Business Pulse Check. This streamlined assessment covers key areas including revenue trends, operational efficiency, team satisfaction, and market positioning. Perfect for busy executives who need quick insights.',
    duration: '10-15 minutes',
    questions: 10,
    price: 29,
    rating: 4.8,
    hasExpertReview: false,
    benefits: [
      'Quick business health snapshot',
      'Identify immediate improvement areas',
      'Benchmark against industry standards',
      'Actionable next steps'
    ],
    sampleQuestions: [
      'How would you rate your current revenue growth compared to your goals?',
      'What is the biggest challenge your business is facing right now?',
      'How satisfied are your customers with your products/services?',
      'How effectively is your team performing their roles?'
    ]
  },
  {
    id: 2,
    title: 'Business Health Audit',
    category: 'strategy',
    complexity: 'intermediate',
    description: 'Comprehensive 25-question analysis covering strategy, operations, finance, and team performance with detailed recommendations.',
    fullDescription: 'Our Business Health Audit provides a thorough examination of your organization across all critical areas. This intermediate-level assessment dives deeper into strategic alignment, operational processes, financial management, and human resources to give you a complete picture of your business health.',
    duration: '25-30 minutes',
    questions: 25,
    price: 79,
    rating: 4.9,
    hasExpertReview: false,
    benefits: [
      'Comprehensive business analysis',
      'Multi-dimensional performance review',
      'Detailed improvement roadmap',
      'Industry benchmarking',
      'Priority-based recommendations'
    ]
  },
  {
    id: 3,
    title: 'Operational Maturity Assessment',
    category: 'operations',
    complexity: 'advanced',
    description: 'In-depth 50+ question evaluation of your operational processes, efficiency, and maturity with expert consultant review.',
    fullDescription: 'The most comprehensive operational assessment available, examining every aspect of your business operations from process design to technology integration. Includes a live expert review session to discuss findings and create a customized improvement plan.',
    duration: '45-60 minutes + 30min expert review',
    questions: 52,
    price: 199,
    rating: 4.9,
    hasExpertReview: true,
    benefits: [
      'Complete operational analysis',
      'Process optimization recommendations',
      'Technology integration assessment',
      'Expert consultant review session',
      'Custom improvement roadmap',
      'Implementation timeline'
    ]
  },
  {
    id: 4,
    title: 'Marketing Effectiveness Audit',
    category: 'marketing',
    complexity: 'intermediate',
    description: 'Analyze your marketing strategies, channels, and ROI with 20 targeted questions about your marketing performance.',
    fullDescription: 'Evaluate the effectiveness of your marketing efforts across all channels and touchpoints. This assessment examines your marketing strategy, execution, measurement, and ROI to identify opportunities for improved performance and growth.',
    duration: '20-25 minutes',
    questions: 20,
    price: 69,
    rating: 4.7,
    hasExpertReview: false
  },
  {
    id: 5,
    title: 'Financial Health Check',
    category: 'finance',
    complexity: 'intermediate',
    description: 'Comprehensive financial analysis covering cash flow, profitability, and financial planning with 28 detailed questions.',
    fullDescription: 'Get a complete picture of your financial health with our comprehensive assessment. Covers cash flow management, profitability analysis, financial planning, risk management, and growth funding strategies.',
    duration: '30-35 minutes',
    questions: 28,
    price: 89,
    rating: 4.8,
    hasExpertReview: false
  },
  {
    id: 6,
    title: 'Sales Operations Review',
    category: 'sales',
    complexity: 'intermediate',
    description: 'Evaluate your sales processes, team performance, and pipeline management with expert insights and recommendations.',
    fullDescription: 'Optimize your sales operations with this comprehensive review of your sales processes, team performance, pipeline management, and customer acquisition strategies. Includes analysis of sales tools, training programs, and performance metrics.',
    duration: '25-30 minutes',
    questions: 24,
    price: 75,
    rating: 4.6,
    hasExpertReview: false
  },
  {
    id: 7,
    title: 'Digital Transformation Readiness',
    category: 'strategy',
    complexity: 'advanced',
    description: 'Assess your organization\'s readiness for digital transformation with 45 questions covering technology, culture, and processes.',
    fullDescription: 'Evaluate your organization\'s digital maturity and readiness for transformation. This advanced assessment examines your current technology stack, digital culture, change management capabilities, and strategic alignment for successful digital transformation.',
    duration: '40-50 minutes',
    questions: 45,
    price: 149,
    rating: 4.8,
    hasExpertReview: true
  },
  {
    id: 8,
    title: 'Customer Experience Audit',
    category: 'marketing',
    complexity: 'intermediate',
    description: 'Analyze your customer journey, satisfaction, and experience across all touchpoints with actionable insights.',
    fullDescription: 'Map and evaluate your entire customer experience from awareness to advocacy. This assessment examines every customer touchpoint, identifies pain points, and provides recommendations for improving customer satisfaction and loyalty.',
    duration: '25-30 minutes',
    questions: 22,
    price: 85,
    rating: 4.7,
    hasExpertReview: false
  },
  {
    id: 9,
    title: 'Leadership Effectiveness Assessment',
    category: 'hr',
    complexity: 'intermediate',
    description: 'Evaluate leadership capabilities, team dynamics, and organizational culture with 26 comprehensive questions.',
    fullDescription: 'Assess the effectiveness of your leadership team and organizational culture. This evaluation covers leadership styles, communication effectiveness, team engagement, decision-making processes, and cultural alignment.',
    duration: '25-30 minutes',
    questions: 26,
    price: 79,
    rating: 4.6,
    hasExpertReview: false
  },
  {
    id: 10,
    title: 'Competitive Analysis Deep Dive',
    category: 'strategy',
    complexity: 'advanced',
    description: 'Comprehensive competitive landscape analysis with 35 questions and expert strategic recommendations.',
    fullDescription: 'Gain deep insights into your competitive position with this thorough analysis of your market landscape, competitor strategies, and differentiation opportunities. Includes expert review session to develop competitive strategies.',
    duration: '35-45 minutes + expert review',
    questions: 35,
    price: 179,
    rating: 4.9,
    hasExpertReview: true
  },
  {
    id: 11,
    title: 'Risk Management Assessment',
    category: 'finance',
    complexity: 'intermediate',
    description: 'Identify and evaluate business risks across operations, finance, and strategy with mitigation recommendations.',
    fullDescription: 'Comprehensive risk assessment covering operational, financial, strategic, and compliance risks. Includes risk prioritization matrix and detailed mitigation strategies for identified vulnerabilities.',
    duration: '30-35 minutes',
    questions: 30,
    price: 95,
    rating: 4.7,
    hasExpertReview: false
  },
  {
    id: 12,
    title: 'Innovation Capability Audit',
    category: 'strategy',
    complexity: 'advanced',
    description: 'Evaluate your organization\'s innovation processes, culture, and capabilities with expert guidance.',
    fullDescription: 'Assess your organization\'s ability to innovate and adapt to market changes. This comprehensive audit examines innovation processes, creative culture, R&D effectiveness, and market responsiveness with expert consultation.',
    duration: '40-50 minutes + expert review',
    questions: 42,
    price: 169,
    rating: 4.8,
    hasExpertReview: true
  }
];